/* sk-header.js — Apple-style header behaviour (AAC, GitHub issue #117).
 *
 * The desktop search dropdown (Ella <predictive-search> + details-modal) and the
 * cart drawer ([data-cart-sidebar]) work via Ella's native JS — including its own
 * Escape/close handling — so this file stays light. The cart pop-out "Sign in to
 * your account" row is a plain link to the account page (reliable; the stacked
 * auth-drawer-over-cart interaction was fragile). Reserved for mobile glue.
 *
 * NOTE: do NOT manually toggle the search <details open> here — bypassing Ella's
 * details-modal close cleanup leaves the sticky header hidden after closing search.
 */
(function () {
  'use strict';

  /* Quick-search chips: clicking a chip should FILL the search box and show live
   * predictive results inline (no page reload). The chip is also a real <a> link
   * to /search?q=… so it still works if JS is unavailable. */
  document.addEventListener('click', function (e) {
    var chip = e.target.closest && e.target.closest('.sk-search-chip');
    if (!chip) return;
    var ps = chip.closest('predictive-search');
    if (!ps) return; // dedicated /search page handles its own chips
    var input = ps.querySelector('input[type="search"], .search__input');
    if (!input) return; // fall back to the link's href
    e.preventDefault();
    var term = chip.getAttribute('data-sk-search-term') || chip.textContent.trim();
    input.value = term;
    input.focus();
    // predictive-search.js listens for 'input' (debounced) → fires the live query
    input.dispatchEvent(new Event('input', { bubbles: true }));
  });

  /* Mobile search drops down BELOW the mobile header. --header-height is 0 on mobile
   * (only the desktop sticky-header sets it), so position the panel at the mobile
   * header's actual bottom edge when it opens. */
  function positionMobileSearch() {
    var panel = document.getElementById('search-form-mobile');
    var mh = document.querySelector('.section-header-mobile');
    if (!panel || !mh) return;
    var bottom = Math.round(mh.getBoundingClientRect().bottom);
    if (bottom > 0) {
      // only set top; max-height is handled by CSS (0 → calc on open) so the reveal animates.
      panel.style.top = bottom + 'px';
    }
  }
  function openMobileSearch() {
    positionMobileSearch();
    // Ella keeps the trending/chips widget .hidden until the input is focused; reveal it
    // on open so the Quick-search chips show immediately (typing re-hides via Ella's JS).
    var panel = document.getElementById('search-form-mobile');
    var widget = panel && panel.querySelector('[data-quick-trending-products]');
    var input = panel && panel.querySelector('input[type="search"], .search__input');
    if (widget && (!input || !input.value)) { widget.classList.remove('hidden'); widget.classList.add('is-show'); }
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-search-mobile]')) {
      requestAnimationFrame(openMobileSearch);
      setTimeout(openMobileSearch, 60);
      setTimeout(openMobileSearch, 220);
    }
  });

  /* The × button inside the mobile search panel (.header-search-close) isn't wired to
   * close by Ella (it only binds the hidden "Close" link + overlay), so close it here. */
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('#search-form-mobile .header-search-close')) {
      e.preventDefault();
      document.body.classList.remove('open_search_mobile');
    }
  });

  /* Kill the close-flicker: our scrim override is scoped to body.open_search_mobile, which
   * is removed instantly on close — so for one frame the shared overlay snaps back to Ella's
   * dark rgba(35,35,35,.8) before fading (the black flash). Keep a light-scrim class on the
   * overlay through the fade-out, then remove it (so the cart/menu overlays are unaffected). */
  var scrimTimer = null;
  new MutationObserver(function () {
    var ov = document.querySelector('.background-overlay');
    if (!ov) return;
    if (document.body.classList.contains('open_search_mobile')) {
      if (scrimTimer) { clearTimeout(scrimTimer); scrimTimer = null; }
      ov.classList.add('sk-search-scrim');
    } else if (ov.classList.contains('sk-search-scrim')) {
      if (scrimTimer) clearTimeout(scrimTimer);
      scrimTimer = setTimeout(function () { ov.classList.remove('sk-search-scrim'); }, 480);
    }
  }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
})();
